import { render } from "./TasksTodoList.vue?vue&type=template&id=8ffc357c&scoped=true"
import script from "./TasksTodoList.vue?vue&type=script&lang=js"
export * from "./TasksTodoList.vue?vue&type=script&lang=js"

import "./TasksTodoList.vue?vue&type=style&index=0&id=8ffc357c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ffc357c"]])

export default __exports__